export function supervisorMembers(members) {
  return (members || []).filter((m) => String(m.memberRole) === 'supervisor');
}

export function scribeIdOf(ticket, members) {
  const id = Number(ticket?.scribeEmployeeId);
  if (id) return id;
  return Number(supervisorMembers(members)[0]?.employeeId) || 0;
}

export function canEditRoom(status) {
  const st = String(status || '');
  return st === 'draft' || st === 'open' || st === '';
}

export function canChangeScribe(status) {
  return canEditRoom(status);
}

export function isSupervisorMember(actorId, members) {
  const id = Number(actorId);
  if (!id) return false;
  return supervisorMembers(members).some((m) => Number(m.employeeId) === id);
}

export function nextScribeId(ticket, members, removeEmployeeId) {
  const drop = Number(removeEmployeeId) || 0;
  const remaining = supervisorMembers(members).filter((m) => Number(m.employeeId) !== drop);
  const current = Number(ticket?.scribeEmployeeId);
  if (current && remaining.some((m) => Number(m.employeeId) === current)) return current;
  return Number(remaining[0]?.employeeId) || 0;
}

function isConfirmed(m) {
  return m?.validatedAt != null && String(m.validatedAt) !== '';
}

export function roomValidation(ticket, members) {
  const supervisors = supervisorMembers(members);
  const scribeId = scribeIdOf(ticket, members);
  const people = supervisors.map((m) => {
    const id = Number(m.employeeId);
    return {
      employeeId: id,
      nameTh: m.nameTh || '',
      employeeCode: m.employeeCode || '',
      isScribe: id === scribeId,
      confirmed: isConfirmed(m),
      confirmedAt: m.validatedAt || null,
    };
  });
  const pending = people.filter((p) => !p.confirmed);
  return {
    status: String(ticket?.status || ''),
    scribeId,
    people,
    pending,
    allConfirmed: people.length > 0 && pending.length === 0,
  };
}

export function actorCanScore(actorId, ticket, members) {
  const st = String(ticket?.status || '');
  if (st === 'finalized' || st === 'cancelled') return false;
  if (!Number(ticket?.scribeEmployeeId)) return true;
  const id = Number(actorId);
  if (!id) return false;
  return id === scribeIdOf(ticket, members);
}

export function actorCanSubmit(actorId, ticket, members) {
  return String(ticket?.status || '') === 'open' && Number(actorId) === scribeIdOf(ticket, members);
}

export function actorCanValidate(actorId, ticket, members) {
  if (String(ticket?.status || '') !== 'submitted') return false;
  const id = Number(actorId);
  if (!id) return false;
  const row = supervisorMembers(members).find((m) => Number(m.employeeId) === id);
  if (!row || isConfirmed(row)) return false;
  return true;
}

/** Nav badge: still needs this actor to submit/score/confirm — skip finalized and already-confirmed. */
export function actorNeedsCalibrateAction(actorId, ticket, members) {
  const id = Number(actorId);
  if (!id) return false;
  if (actorCanValidate(id, ticket, members)) return true;
  if (actorCanSubmit(id, ticket, members)) return true;
  const st = String(ticket?.status || '');
  if (st === 'draft' || st === '') {
    return isSupervisorMember(id, members) && actorCanScore(id, ticket, members);
  }
  return false;
}

/** Resolve actor from room roster first, then employee directory (any status). */
export function actorIdFromCode(actorEmployeeCode, employees, roomMembers) {
  const code = String(actorEmployeeCode || '').trim();
  if (!code) return 0;
  const hit = [...(roomMembers || []), ...(employees || [])].find(
    (e) => String(e.employeeCode || '').trim() === code
  );
  return Number(hit?.employeeId) || 0;
}

/** True when every question index 0..count-1 has been opened. */
export function allQuestionsViewed(seen, questionCount) {
  const n = Math.max(0, Number(questionCount) || 0);
  if (!n) return false;
  const set = seen instanceof Set ? seen : new Set(Array.isArray(seen) ? seen : []);
  return Array.from({ length: n }, (_, i) => i).every((i) => set.has(i));
}
